import { Avatar, Box, Checkbox, IconButton, TableRow, Typography } from '@mui/material';
import { Edit, Add } from '@mui/icons-material';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';

import { useActions } from '../../../../hooks/useActions';
import { useTypedSelector } from '../../../../hooks/useTypedSelector';

import { IAnnouncementInfo } from '../types';
import { HeadCell } from '../../../../store/types';

import LinkRouter from '../../../../components/LinkRouter';
import EnhancedTable from '../../../../components/EnhancedTable';
import { TableCellStyle } from '../../../../components/EnhancedTable/styled';
import IconButtonPlus from '../../../../components/Button/IconButtonPlus';


const AnnouncementTable = () => {
    const navigate = useNavigate();

    const headCells: HeadCell<IAnnouncementInfo>[] = [
        {
            id: 'id',
            numeric: true,
            label: 'Ідентифікатор',
        },
        {
            id: 'title',
            numeric: false,
            label: `Заголовок`,
        },
        {
            id: 'imagePreview',
            numeric: false,
            label: `Фото картки`,
        },
        {
            id: 'hashtag',
            numeric: false,
            label: `Тег`,
        },
        {
            id: 'date',
            numeric: false,
            label: `Дата`,
        }
    ];

    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(8);
    const [name, setName] = useState("");
    const [isAscOrder, setIsAscOrder] = useState<boolean>(true);
    const [orderBy, setOrderBy] = useState<keyof IAnnouncementInfo>('id');

    const [selected, setSelected] = useState<readonly number[]>([]);

    const { SearchAnnouncements, DeleteAnnouncements } = useActions();
    const { announcements, count } = useTypedSelector((store) => store.announcement);

    useEffect(() => {
        document.title = 'Анонси';
        getData();
    }, [page, rowsPerPage, name, isAscOrder, orderBy]);

    const getData = async () => {
        try {
            await SearchAnnouncements(false, page, rowsPerPage, name, isAscOrder, orderBy);
            setSelected([]);
        } catch (ex) {
        }
    };

    const onDelete = async () => {
        await DeleteAnnouncements(selected);
        if (page == 1)
            getData()
        else
            await setPage(1);
    }

    const handleClick = (event: React.MouseEvent<unknown>, id: number) => {
        const selectedIndex = selected.indexOf(id);
        let newSelected: readonly number[] = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }

        setSelected(newSelected);
    };

    const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (selected.length == 0) {
            const newSelecteds = announcements.map((n) => n.id);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };

    const isSelected = (id: number) => selected.indexOf(id) !== -1;

    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(1);
    };

    return (
        <>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", my: "30px" }}>
                <Typography variant="h1" color="inherit">Анонси</Typography>
                <LinkRouter underline="none" color="inherit" to="/admin/announcements/create" >
                    <IconButtonPlus onClick={() => { }} />
                </LinkRouter>
            </Box>
            <EnhancedTable
                page={page}
                rowsPerPage={rowsPerPage}
                handleChangePage={handleChangePage}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
                setName={setName}
                handleSelectAllClick={handleSelectAllClick}
                isAscOrder={isAscOrder}
                setIsAscOrder={setIsAscOrder}
                orderBy={orderBy}
                setOrderBy={setOrderBy}
                headCells={headCells}
                numSelected={selected.length}
                count={count}
                show={null}
                update={<Edit onClick={() => { navigate(`/admin/announcements/update/${selected[0]}`); window.scrollTo({ top: 0, behavior: 'smooth' }); }} />}
                onDelete={onDelete}
                tableBody={announcements.map((row, index) => {
                    const isItemSelected = isSelected(row.id);
                    const labelId = `enhanced-table-checkbox-${index}`;

                    return (
                        <TableRow
                            hover
                            onClick={(event) => handleClick(event, row.id)}
                            role="checkbox"
                            aria-checked={isItemSelected}
                            tabIndex={-1}
                            key={row.id}
                            selected={isItemSelected}
                        >
                            <TableCellStyle sx={{ paddingLeft: "11px" }} padding="checkbox">
                                <Checkbox
                                    color="primary"
                                    sx={{ borderRadius: "12px" }}
                                    checked={isItemSelected}
                                    inputProps={{
                                        'aria-labelledby': labelId,
                                    }} />
                            </TableCellStyle>
                            <TableCellStyle
                                component="th"
                                id={labelId}
                                scope="row"
                            >
                                {row.id}
                            </TableCellStyle>
                            <TableCellStyle align="center">{row.title}</TableCellStyle>
                            <TableCellStyle align="center">
                                <Avatar
                                    sx={{ mx: "auto" }}
                                    src={row.imagePreview}
                                />
                            </TableCellStyle>
                            <TableCellStyle align="center">{row.hashtag}</TableCellStyle>
                            <TableCellStyle align="center">{dayjs(row.date).format('DD/MM/YYYY')}</TableCellStyle>
                        </TableRow>
                    );
                })} />
        </>
    );
}

export default AnnouncementTable;